export { default } from './SkeletonPopularDestinationsMobile';
